import React, { PropsWithChildren } from 'react';
import theme from './Button.module.scss';
import { withSubComponents } from '@/utils/react';
import { classnames } from '@/utils/html';

interface ButtonBarProps extends PropsWithChildren {
    className?: string;
}

interface SeparatorProps {
    className?: string;
}

const Right: React.FC<ButtonBarProps> = ({ children, className }) => {
    return <div className={classnames(theme.right, className)}>{children}</div>;
};

const Left: React.FC<ButtonBarProps> = ({ children, className }) => {
    return <div className={classnames(theme.left, className)}>{children}</div>;
};

const Separator: React.FC<SeparatorProps> = ({ className }) => {
    return <div className={classnames(theme.separator, className)} />;
};

const ButtonBar: React.FC<ButtonBarProps> = ({ children, className }) => {
    return <div className={classnames(theme.buttonBar, className)}>{children}</div>;
};

export default withSubComponents(ButtonBar, { Right, Left, Separator });
